/*
  <product-form> wraps any add-to-cart form: the product page, product-card
  quick add, and the "complete the kit" bundle (which posts items[n][id]).
  It adds via the AJAX Cart API, asks Shopify to render the cart drawer +
  cart bubble in the same request, and hands the result to <cart-drawer>.
*/
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('[data-button-text]');
        this.hideErrors = this.dataset.hideErrors === 'true';
        if (this.variantIdInput) this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      get cart() {
        return document.querySelector('cart-drawer');
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      onSubmit(event) {
        event.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Without the drawer (cart type "page"), a normal form post is the right behaviour.
        if (!this.cart) {
          this.form.submit();
          return;
        }

        this.showError(false);
        this.setLoading(true);

        const formData = new FormData(this.form);
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        fetch(routes.cart_add_url, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.showError(response.description || response.message);
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });
            this.cart.classList.remove('is-empty');
            this.cart.renderContents(response);
          })
          .catch((error) => {
            console.error(error);
            this.showError(window.cartStrings.error);
          })
          .finally(() => this.setLoading(false));
      }

      setLoading(isLoading) {
        this.submitButton.classList.toggle('loading', isLoading);
        if (isLoading) {
          this.submitButton.setAttribute('aria-disabled', 'true');
        } else {
          this.submitButton.removeAttribute('aria-disabled');
        }
      }

      showError(message = false) {
        if (this.hideErrors) return;
        const wrapper = this.querySelector('.product-form__error-message-wrapper');
        if (!wrapper) return;
        wrapper.toggleAttribute('hidden', !message);
        if (message) wrapper.querySelector('.product-form__error-message').textContent = message;
      }

      // Used by the product page when the selected variant changes.
      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;
        this.submitButton.toggleAttribute('disabled', disable);
        if (this.submitButtonText && text) this.submitButtonText.textContent = text;
      }
    }
  );
}
